import { React, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import useToken from '../../util/useToken';

import { getOAMaintenances } from '../../util/api';
import { updateOAMaintenance } from '../../util/api';
import { addOAMaintenance } from '../../util/api';
import { deleteOAMaintenance } from '../../util/api';

import { getFilterOptions } from '../../util/api';
import NumberInput from '../NumberInput';
import DateTimeInput from '../DateTimeInput';
import DropDownInput from '../DropDownInput';
import TextInput from '../TextInput';

import { format } from 'date-fns';

import './OAMaintenance.css'

export default function OAMaintenance ( { OAID } ) {
    const [ loading, setLoading ] = useState(true);
    const loadingGIF = require('../../content/loading.gif');
    const { token, setToken, removeToken, validToken} = useToken();
    const [ firstLoad, setFirstLoad ] = useState(true);
    const [ OAMAnalysis, setOAMAnalysis ] = useState({"results":[]});
    const [ editMode, setEditMode ] = useState(false);
    const [ viewMode, setViewMode ] = useState(false);
    const [ selectedId, setSelectedId ] = useState(null);
    const [ refresh, setRefresh ] = useState(null);
    const [ viewingSanger, setViewingSanger ] = useState(false);

    //Pagination variables
    const [ page, setPage ] = useState(1)
    const [ editedPage, setEditedPage] = useState(1);
    const [ pageSize, setPageSize ] = useState(5)
    const [ resultCount, setResultCount ] = useState(0);

    const [options, setOptions] = useState({"windDirections":[], "conditions":[], "species":[], "siteMarshes":[], "storageBuffers":[], "sites":[], "imageTypes":[]});
    
    const [ currentObject, setCurrentObject ] = useState({});

    const handleCheckboxChange = (event, id) => {
        if(id === selectedId){
            setSelectedId(null)
        }else{
            setSelectedId(id);
        }
    };

    useEffect(() => {
        getOAMaintenances(token, OAID, page, pageSize).then(response => {
            response.json().then(json => {
                if(response.status !== 200){
                    alert(json["message"])
                }else{
                    setOAMAnalysis(json)
                    setResultCount(json["resultCount"])
                }
            })
            setRefresh(false)
            setLoading(false)
        })
    }, [refresh, page])

    const handleInputChange = (event, name) => {
        setCurrentObject({
            ...currentObject,
            [name]: event.target.value,
        });
        
        const updatedInformation = {
            ...OAMAnalysis,
            results: OAMAnalysis.results.map(item => {
                if (item.id === editMode) {
                    return {
                        ...item,
                        [name]: event.target.value
                    };
                }
                return item;
            })
        };
    
        setOAMAnalysis(updatedInformation);

    };

    useEffect(() => {
        const fetchOptions = async () => {
            let options = await getFilterOptions(token);
            setOptions(options)
        }
        fetchOptions();
    }, []);

    const deleteOAMAnalysisRow = () => {
        deleteOAMaintenance(token, selectedId).then(response => {
            response.json().then(json => {
                if(response.status !== 200){
                    alert(json["message"])
                }else{
                    setRefresh(true)
                    setSelectedId(null)
                }
            })
        }) 
    }
    
    const addOAMAnalysisRow = () => {
        setCurrentObject({"id":-1, "oceanacidificationID":OAID})
        setEditMode(true)
        setViewMode(true)
        setSelectedId(-1)
    }

    const handleOnClickEditOrSave = () => {
        if(editMode == true){
            if(currentObject["id"] !== -1){
                updateOAMaintenance(token, currentObject).then(response => {
                    response.json().then(json => {
                        if(response.status !== 200){
                            alert(json["message"])
                        }else{
                            setEditMode(false)
                            setRefresh(true)
                        }
                    })
                })
            }else{
                addOAMaintenance(token, currentObject).then(response => {
                    response.json().then(json => {
                        if(response.status !== 200){
                            alert(json["message"])
                        }else{
                            setEditMode(false)
                            setRefresh(true)
                        }
                    })
                })
            }
        }else{
            setEditMode(true)
        }
    }

    const handleFowardClick = () => {
        if(page < (resultCount / pageSize)){
            setPage(page + 1)
        }
    }

    const handleBackClick = () => {
        if(page > 1 ){
            setPage(page - 1)
        }
    }
    
    return(
        <div>
            {(loading || refresh) && 
                <div className="loading-position">
                    <img src={loadingGIF}></img>
                </div>
            }
            {!viewMode &&
            <div className="OAM-table-container">
                <div className="OAM-table-buttons">
                    <div>
                        <button disabled={!selectedId} onClick={() => {setViewMode(true); setCurrentObject(OAMAnalysis?.results.find(item => item.id === selectedId))}}>View</button>
                        <button onClick={() => {addOAMAnalysisRow()}}>Add</button>
                        <button disabled={!selectedId} onClick={() => {deleteOAMAnalysisRow()}}>Delete</button>
                    </div>
                    <div>
                        <button onClick={() => {handleBackClick()}}>{"<"}</button>
                        <input
                            className="page-input"
                            type="number"
                            value={editedPage}
                            onChange={(event) => {setEditedPage(event.target.valueAsNumber || editedPage)}}
                            onBlur={(event) => {
                                const enteredPage = event.target.valueAsNumber || editedPage;
                                const maxPage = Math.ceil(resultCount / pageSize);
                                setPage(Math.max(1, Math.min(enteredPage, maxPage)));
                                setEditedPage(Math.max(1, Math.min(enteredPage, maxPage)));
                              }}
                        />
                        <button onClick={() => {handleFowardClick()}}>{">"}</button>
                    </div>    
                </div>
                <table className="OAM-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Date</th>
                            <th>PH Meter</th>
                            <th>Salinity</th>
                        </tr>
                    </thead>
                    <tbody>
                        {OAMAnalysis?.results.length > 0 && OAMAnalysis?.results?.map((result) => (
                            <tr key={result.id}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedId === result.id}
                                        onChange={event => handleCheckboxChange(event, result.id)}
                                    />
                                </td>
                                <td>{result.date?.replace("T", " ")} </td>
                                <td>{result.pHMeter}</td>
                                <td>{result.salinity}</td>
                            </tr>
                        ))}
                        {OAMAnalysis?.results.length == 0 &&
                            <tr>
                                <td colSpan="6" style={{ textAlign: 'center' }}>
                                    <p>No Results</p>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
                {resultCount !== 0 ? <p>{page}/{Math.ceil(resultCount/pageSize)}</p> : <p></p>}
            </div>   
            }
            {(viewMode && selectedId) &&
            <div>
                <div>
                    <button onClick={() => {setViewMode(false); setRefresh(true); setEditMode(false)}}>Back</button>
                    <button onClick={() => {handleOnClickEditOrSave()}}>{editMode ? "Save" : "Edit"}</button>
                </div>
                <div className="information-container">
                    <div>
                        <div>
                            <DateTimeInput
                                label="Date"
                                value={currentObject["date"]} 
                                onChange={(event) => {handleInputChange(event, "date")}}
                                editable={editMode}
                            />
                            <NumberInput
                                label="PH Meter"
                                value={currentObject["pHMeter"]} 
                                onChange={(event) => {handleInputChange(event, "pHMeter")}}
                                editable={editMode}
                            />
                            <NumberInput
                                label="Salinity"
                                value={currentObject["salinity"]} 
                                onChange={(event) => {handleInputChange(event, "salinity")}}
                                editable={editMode}
                            />
                            <NumberInput
                                label="Meter Calibration"
                                value={currentObject["meterCalibration"]} 
                                onChange={(event) => {handleInputChange(event, "meterCalibration")}}
                                editable={editMode}
                            />
                            <NumberInput
                                label="Diatom Volume Fed"
                                value={currentObject["diatomVolumeFed"]} 
                                onChange={(event) => {handleInputChange(event, "diatomVolumeFed")}}
                                editable={editMode}
                            />
                            <NumberInput
                                label="Diatom Calibration"
                                value={currentObject["diatomConc"]} 
                                onChange={(event) => {handleInputChange(event, "diatomConc")}}
                                editable={editMode}
                            />
                            <TextInput
                                label="Diatom Species"
                                value={currentObject["diatomSpecies"]} 
                                onChange={(event) => {handleInputChange(event, "diatomSpecies")}}
                                editable={editMode}
                            />
                        </div>
                    </div>                          
                </div>
            </div>
            }
        </div>
    );
}